export default "__VITE_ASSET__BXqQVCpg__"